import { Container } from 'typescript-ioc'

/**
 * ServiceLocator class.
 */
export class ServiceLocator {
  /**
   * Get or create an instance of a service.
   *
   * @param ctor Type constructor reference.
   * @return T
   */
  public static resolve<T> (ctor: { new (): T }): T {
    const instance = Container.get<T>(ctor)

    if (!(instance instanceof ctor)) {
      throw new Error(`"${ctor.name}" is not a valid service.`)
    }

    return instance
  }
}
